import { REPORT_LEVEL_E, REPORT_APPLICATION_STATUS_E, REPORT_APPLICATION_TYPE_E, REPORT_DATE_TYPE_E, REPORT_GROUP_BY_E, REPORT_SORT_BY_E, REPORT_RISK_LEVEL_E, REPORT_CASHFLOW_E } from "@Broker/@Types/reports/types";
const store = {
  showWelcomeModal: false,
  showPaymentFailureModal: false,
  userDetails: {
    email: "",
    username: "",
    givenName: "",
    familyName: "",
    middleName: "",
    phoneNumber: "",
    altPhoneNumber: "",
    profilePhoto: null,
    photoVersion: 0,
    address: {}
  },
  accountDetails: {
    accountStatus: "",
    accountType: "",
    accountPlan: "",
    accountSubdomain: "",
    expirationDate: "",
    timezone: "",
    agreedToRemarketingTerms: null,
    localeLanguage: "en-CA",
    licenseType: "",
    accessRights: {
      viewOnly: false,
      editCommissions: true,
      requestCreditBureaus: true,
      submitApplications: true,
      coBroker: true,
      overrideCobrokering: true
    },
    clientIsRetired: false
  },
  accountPreferences: {
    clientBoardView: "",
    tutorial: null,
    includeExisting: true,
    featureDiscovery: null,
    applicationFeatureDiscovery: null,
    emailSignature: "",
    followUpNotificationTime: "",
    defaultEmailId: "",
    defaultEmailName: "",
    defaultListId: "",
    applicationAutomationTime: "",
    reportDefaultSettings: {
      applicationSummary: {
        level: REPORT_LEVEL_E.EMPTY,
        agents: "",
        lender: "",
        applicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
        applicationType: REPORT_APPLICATION_TYPE_E.EMPTY,
        referralSource: "",
        dateType: REPORT_DATE_TYPE_E.EMPTY,
        dateFrom: "",
        dateTo: "",
        groupBy: REPORT_GROUP_BY_E.EMPTY,
        sortByPrimary: REPORT_SORT_BY_E.EMPTY,
        sortBySecondary: REPORT_SORT_BY_E.EMPTY
      },
      firmStatistics: {
        agents: "",
        level: REPORT_LEVEL_E.EMPTY,
        dateFrom: "",
        dateTo: "",
        dateType: REPORT_DATE_TYPE_E.EMPTY,
        applicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
        annualInformationReturn: false
      },
      renewalTracking: {
        agents: "",
        level: REPORT_LEVEL_E.EMPTY,
        lender: "",
        groupBy: REPORT_GROUP_BY_E.EMPTY,
        sortByPrimary: REPORT_SORT_BY_E.EMPTY,
        sortBySecondary: REPORT_SORT_BY_E.EMPTY,
        maturityDateFrom: "",
        maturityDateTo: "",
        mortgageType: "",
        requestType: "all"
      },
      lenderTransactions: {
        agents: "",
        level: REPORT_LEVEL_E.EMPTY,
        lender: "",
        groupBy: REPORT_GROUP_BY_E.EMPTY,
        sortByPrimary: REPORT_SORT_BY_E.EMPTY,
        sortBySecondary: REPORT_SORT_BY_E.EMPTY,
        dateFrom: "",
        dateTo: "",
        dateType: REPORT_DATE_TYPE_E.EMPTY,
        applicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
        annualInformationReturn: false
      },
      riskLevel: {
        agents: "",
        level: REPORT_LEVEL_E.EMPTY,
        dateFrom: "",
        dateTo: "",
        dateType: REPORT_DATE_TYPE_E.EMPTY,
        applicationStatus: REPORT_APPLICATION_STATUS_E.ALL,
        riskLevels: REPORT_RISK_LEVEL_E.ALL
      },
      commissions: {
        level: REPORT_LEVEL_E.EMPTY,
        agents: "all",
        feeType: "",
        deductionType: "",
        cashflow: REPORT_CASHFLOW_E.PAID,
        applicationStatus: REPORT_APPLICATION_STATUS_E.EMPTY,
        format: "",
        dateType: REPORT_DATE_TYPE_E.EMPTY,
        dateFrom: "",
        dateTo: "",
        groupBy: REPORT_GROUP_BY_E.EMPTY,
        sortByPrimary: REPORT_SORT_BY_E.EMPTY,
        sortBySecondary: REPORT_SORT_BY_E.EMPTY
      }
    },
    aiEmailDefaultSettings: {}
  },
  brokerageDetails: {
    tiedBrokerages: [{
      brokerageId: "",
      subdomain: "",
      name: "",
      franchise: "",
      sharedReferrer: false,
      referralSourceEnabled: false,
      referralApiPartners: {}
    }]
  },
  permissions: {
    accountCustomization: "write",
    brokerageClients: "write",
    brokerageAgents: "write",
    brokerageCustomization: "write",
    brokerageSettings: "write",
    reportingDashboardCustomization: "write",
    remarketingCampaign: "write"
  },
  apiBasePath: "/brokers",
  token: "",
  xData: {
    id: "",
    ref: ""
  },
  email: "",
  expiration: "",
  lastCacheCheck: null,
  boardId: null,
  notificationPreferences: {},
  boardClassicFilters: {},
  clientBoardView: "dynamic",
  locale: "",
  styles: {}
};
export default store;